import { useBeaconFilters } from 'src/components/BeaconV2Components/ExperimentalLayout/Forecasts/serverProxy/useBeaconFilters';
import { TopicRequestBuilder } from './TopicRequestBuilder';
import { useMainEntityType, useRetailerId } from 'src/utils/Hooks/reduxSelectors';
import { useAppSelector } from 'src/utils/Hooks';
import { isTopicEntity } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils';
import { TopicExportRequestBuilder } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/utils/TopicExportRequestBuilder';

/**
 * For topics requests, adds the category, subcategory, and segment filters
 * if they are applied
 */
export const useBaseTopicRequestBuilder = (isExport?: boolean) => {
  const { hasActiveFilters, appFilters } = useBeaconFilters();
  const entityType = useMainEntityType();
  const entityId = useAppSelector((state) => state.entityService.mainEntity?.id);
  const retailerId = Number(useRetailerId());

  const requestBuilder = isExport ? new TopicExportRequestBuilder() : new TopicRequestBuilder();

  if (entityType === 'category') {
    requestBuilder.setCategoryIds([+entityId]);
  } else if (entityType === 'subcategory') {
    requestBuilder.setSubcategoryIds([+entityId]);
  } else if (entityType === 'segment') {
    requestBuilder.setSegmentIds([`${entityId}`]);
  } else if (isTopicEntity(entityType)) {
    requestBuilder.setTopicIds([`${entityId}`]);
  } else if (entityType === 'topicgroup') {
    requestBuilder.setTopicGroupIds([`${entityId}`]);
  } else if (entityType === 'brand') {
    requestBuilder.setBrandIds([+entityId]);
  } else if (entityType === 'product') {
    requestBuilder.setStacklineSkus([`${entityId}`]);
  }

  if (hasActiveFilters) {
    const { categoryFilters, subcategoryFilters, segmentFilters } = appFilters;

    if (categoryFilters) {
      requestBuilder.setCategoryIds(categoryFilters as number[]);
    }

    if (subcategoryFilters) {
      requestBuilder.setSubcategoryIds(subcategoryFilters as number[]);
    }
    if (segmentFilters) {
      requestBuilder.setSegmentIds([segmentFilters.id]);
    }
  }

  requestBuilder.setRetailerId(retailerId);

  return requestBuilder;
};
